import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger from '@wix/bi-logger-wix-answers';
import { BIEvent } from '../event-type';
import { getCookieByName, MARKETING_COOKIE_NAME, CAMPAIGN_COOKIE_NAME } from '../../utils';
import { ensureAnonId, getAnonId } from '@wix/answers-bi';

// tslint:disable-next-line:no-var-requires
require('es6-shim');

const getQueryParam = (name: string) => {
	const url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	const results = regex.exec(url);
	if (!results) {
		return undefined;
	}
	if (!results[2]) {
		return undefined;
	}
	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const createWixBiHandler = () => {
	const logger = initSchemaLogger(webBiLogger)();

	try {
		ensureAnonId();
	} catch (e) {
		// tslint:disable-next-line:no-console
		console.error('error creating wix client id', e);
	}

	return (eventType: BIEvent, data: any = {}) => {
		const maybeMarketingId = getCookieByName(MARKETING_COOKIE_NAME);
		const maybeCampaignId = getCookieByName(CAMPAIGN_COOKIE_NAME);

		const utmCampaign = getQueryParam('utm_campaign');
		const utmSource = getQueryParam('utm_source');

		const APP_PAGE_TYPE = 'App';
		const maybeLastReferrer = getCookieByName('wamk_most_recent_ref') || getCookieByName('_uc_last_referrer') || '';

		const marketingId = maybeMarketingId ? {marketing_id: maybeMarketingId} : {};
		const campaignId = maybeCampaignId ? {campaign_id: parseInt(maybeCampaignId, 10)} : {};
		const referralName = data.referral_name ? {referral_name: data.referral_name} : {};
		const referralUrl = data.referral_url ? {referral_url: data.referral_url} : {};
		const pageUrl = data.page_url ? {page_url: data.page_url} : {};

		const sharedData = {
			...marketingId,
			...campaignId,
			...referralName,
			...referralUrl,
			...pageUrl,
			locale: data.locale || 'en',
			client_id: getAnonId() || undefined,
			page_type: APP_PAGE_TYPE,
			last_referrer: maybeLastReferrer
		};

		switch (eventType) {
			case BIEvent.PAGE_VIEW:
				logger.marketingPageView({
					...sharedData,
					utm_campaign: utmCampaign,
					utm_source: utmSource,
					page_url: data.page_url
				});
				break;

			case BIEvent.SSO_SIGNUP_CLICK:
				logger.marketingSignUpClickSignUpWithSso({
					...sharedData,
					sso_type: data.type
				});
				break;

			case BIEvent.SIGNUP_CLICK_STEP1:
				logger.marketingClickSubmitSignUpForm(sharedData);
				break;

			case BIEvent.SIGNUP_SUCCESS_STEP1:
				logger.marketingSignUpSignUpSuccessFirstStep(sharedData);
				break;

			case BIEvent.SIGNUP_FAILED_STEP1:
				logger.marketingSignUpSignUpFailedFirstStep({
					...sharedData,
					error_reason: data.error
				});
				break;

			case BIEvent.SIGNUP_CLICK_STEP2:
				logger.marketingSignUpSubmitSignUpSecondStep({
					...sharedData,
					subdomain: data.subdomain
				});
				break;

			case BIEvent.SIGNUP_SUCCESS_STEP2:
				logger.marketingSignUpSignUpSuccessSecondStep({
					...sharedData,
					subdomain: data.signupParams.subdomain,
					tenant_id: data.tenant.id,
					user_id: data.tenant.adminUserId,
					sign_up_method: data.signupType
				});
				break;

			case BIEvent.SIGNUP_FAILED_STEP2:
				logger.marketingSignUpSignUpFailedSecondStep({
					...sharedData,
					error_reason: data.error,
					subdomain: data.subdomain
				});
				break;

			case BIEvent.LOGIN_NEXT_CLICK:
				logger.marketingLogInSubmitPreLoginRedirectToAnswersUrl({
					...sharedData,
					subdomain: data.subdomain
				});
				break;

			case BIEvent.LOGIN_REDIRECT_SUCCESS:
				logger.marketingLogInPreLoginRedirectSuccess({
					...sharedData,
					subdomain: data.subdomain
				});
				break;

			case BIEvent.LOGIN_REDIRECT_FAIL:
				logger.marketingLogInPreLoginRedirectFailed({
					...sharedData,
					error_reason: data.error
				});
				break;

			default:
				// event not handled at wix
				break;
		}
		return Promise.resolve();
	};
};
